import { z } from '@harvestiq/zod';

export const deleteCampaignParamsSchema = z.object({
  campaignId: z.string().uuid(),
});

export type DeleteCampaignParams = z.infer<typeof deleteCampaignParamsSchema>;
